module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-injekcni-metody_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/laserova-estetika/vyhlazeni-vrasek-injekcni-metody_1_after.jpg
// module id = 1017
// module chunks = 0